export default "/images/vendor/@coreui/icons/svg/flag/cif-tg.svg?5134ed58f96780c8ff2947d521a9134e";